import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { gsap } from "gsap";
import { ReactComponent as User } from "../user.svg";
import { Link, useLocation } from 'react-router-dom';

const Navbar = ({scrollProgress}) => {

  const navRef = useRef();
  const toggleRef = useRef();

  const [ mounted, setMounted ] = useState(false);
  const location = useLocation();

  const handleLink = () => {
    setNavOpen(false);
    setMounted(true);
  };

  useLayoutEffect(() => {

    setTimeout(() => {
      setMounted(true);
    }, 1000);

  }, []);

  useEffect(() => {

    if(scrollProgress > 0 && navRef.current && mounted) {
      gsap.to(navRef.current, {
        opacity: 0,
        transform: largeScreen ? "translateY(-100px) translateX(-50%)" : "translateY(-100px) translateX(0)",
        duration: 0.3
      });
    }

    if(scrollProgress > 0 && toggleRef.current && mounted) {
      gsap.to(toggleRef.current, {
        opacity: 0,
        transform: "translateX(120%)",
        duration: 0.3
      });
    }

    if(scrollProgress === 0 && navRef.current && mounted) {
      gsap.to(navRef.current, {
        opacity: 1,
        transform: largeScreen ? "translateY(0) translateX(-50%)" : "translateY(0) translateX(0)",
        duration: 0.3,
      });
    }

    if(scrollProgress === 0 && toggleRef.current && mounted) {
      gsap.to(toggleRef.current, {
        opacity: 1,
        transform: "translateX(0)",
        duration: 0.3,
      });
    }

  }, [scrollProgress, mounted]);

  const [ largeScreen, setLargeScreen ] = useState(window.innerWidth >= 1100);

  useEffect(() => {

      const handleResize = () => {

        setLargeScreen(window.innerWidth >= 1100);

        if(window.innerWidth >= 1100) {
          setNavOpen(false);
        }

      };

      window.addEventListener("resize", handleResize);

      return () => {
          window.removeEventListener("resize", handleResize);
      };

  }, []);

  const togglerRefs = useRef([]);
  togglerRefs.current = [];

  const addRefs = (el) => {
    if (el && !togglerRefs.current.includes(el)) {
      togglerRefs.current.push(el);
    }
  };

  const [ navOpen, setNavOpen ] = useState(false);

  useEffect(() => {

    if(togglerRefs.current.length > 0) {

      const elems = togglerRefs.current;

      elems.forEach((el, index) => {

        if(index === 1) {
          gsap.to(el, {
            opacity: navOpen ? 0 : 1,
            duration: 0.3,
          });
        }

        if(index === 0) {
          gsap.to(el, {
            transform: navOpen ? "rotateZ(-45deg) translateY(-3.5px)" : "rotateZ(0) translateY(0)",
            transformOrigin: "right top",
            background: navOpen ? "var(--white)" : "var(--blue)",
            duration: 0.3,
          });
        }

        if(index === 2) {
          gsap.to(el, {
            transform: navOpen ? "rotateZ(45deg) translateY(3.5px)" : "rotateZ(0) translateY(0)",
            transformOrigin: "right bottom",
            background: navOpen ? "var(--white)" : "var(--blue)",
            duration: 0.3,
          });
        }

      });

    }

    if(navOpen) {
      document.documentElement.style.overflowY="hidden";
    } else {
      document.documentElement.style.overflowY="auto";
    }

  }, [navOpen]);

  const [logo, setLogo] = useState("");
  const logoRef = useRef();
    
  const getLogo = async () => {
      try {
          const response = await fetch("/logos/logo.svg");
          if (response.ok) {
              const data = await response.text();
              setLogo(data);
          } else {
              console.log("SVG logo wasn't loaded!");
          }
      } catch (err) {
          console.error(err);
      }
  };
  
  useEffect(() => {
      if(navOpen) {
        getLogo();
      }
  }, [navOpen]);

  useLayoutEffect(() => {

    if (!logoRef.current) return;

    const tl = gsap.timeline();
    if (logoRef.current && navOpen && logo) tl.to(logoRef.current, { opacity: 1, x: 0, duration: 0.3 }, 0.4);

  }, [navOpen, logo]);

  return (
    <>
      <div className={largeScreen ? "no-navbar" : "navbar-toggler"} onClick={() => setNavOpen(!navOpen)} ref={toggleRef}>

          <div className="toggler-line" ref={addRefs}>

          </div>

          <div className="toggler-line" ref={addRefs}>
            
          </div>

          <div className="toggler-line" ref={addRefs}>
            
          </div>

        </div>

      <div className={largeScreen ? "navbar" : navOpen ? "navbar-open" : ""} ref={navRef} style={{transform: largeScreen ? "translateX(-50%)" : "translateX(0)"}}>

        {(largeScreen || navOpen) &&
          <>
            <div className={largeScreen ? "navbar-items flex-row" : "navbar-open-items"}>

              <Link to="/" onClick={handleLink}>
                <p className={location.pathname === "/" ? "link-underline" : ""}>Home</p>
              </Link>

              <Link to="/uebungen" onClick={handleLink}>
                <p>Übungen</p>
              </Link>

              <Link to="/quiz" onClick={handleLink}>
                <p>Quiz Mode</p>
              </Link>

              {!largeScreen &&
                <Link to="/admin" onClick={handleLink}>
                  <div className="navbar-login flex-row">

                    <User /> 

                    <p style={{marginTop: 0}}>Login</p>

                  </div>
                </Link>
              }

            </div>

            {largeScreen &&

              <Link to="/admin">
                <div className="navbar-login flex-row">

                  <User /> 
                    
                  <p style={{marginTop: 0}}>Login</p>

                </div>
              </Link>
            }

            {(logo && !largeScreen) &&
              <div 
              className="flex-row"
              ref={logoRef}
              style={{
                  opacity: 0, 
                  transform: "translateX(-100%)",
                  gap: 0,
                  width: "min-content",
                  position: "absolute",
                  bottom: 10,
                  left: 10
              }}
              >
                  <div
                      className="nav-logo"
                      dangerouslySetInnerHTML={{ __html: logo }}
                      style={{
                        marginTop: "-0.2rem",
                        height: "1rem",
                        width: "1rem",
                        filter: "brightness(0) invert(1)"
                      }}
                  />

                  <div>
                      <h1 className="title" style={{color: "var(--white)", fontSize: "1rem"}}>RAMMATISCH</h1>
                  </div>
              </div>
            }
          </>
        }

      </div>
    </>
  );
};

export default Navbar;